@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.label {
  @include typography-v2-body-xs;
}

.labelContainer {
  display: flex;
  align-items: center;
  background-color: var(--surface-default);
  @include border-radius-r1;
  padding: 2px 6px 2px 0;
  cursor: default;
}

.labelRoot {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
